<template>
    <section class="w-screen h-screen absolute flex justify-center items-center z-50">
        <div id="modal modal-customer" class="modal absolute block w-5/6 bg-white shadow-md rounded-lg" :class="{
            'animate__animated animate__zoomIn': showModal,
            'animate__animated animate__zoomOut': !showModal,
        }">
            <div id="modal-header" class="w-full bg-color-1 py-3 rounded-t-lg">
                <h5 class="text-white text-center font-bold text-xl">Filter Transaksi</h5>
            </div>
            <div id="modal-body"
                class="p-5 max-h-[calc(100dvh-220px)] overflow-y-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                <div class="flex flex-col gap-2">
                    <label class="font-medium text-dark-600 dark:text-dark-400">Range Tanggal</label>
                    <DatePicker v-model="rangeDate" selectionMode="range" :manualInput="false" />
                </div>
                <InputSelect v-model="selectedType" label="Tipe Order" id="filter-status" :options="allTypes"
                    placeholder="Pilih tipe order" optionLabel="name" optionValue="id" />
                <InputSelect v-model="selectedTableId" label="Meja" id="filter-meja" :options="allTables"
                    placeholder="Pilih meja" optionLabel="name" optionValue="id" :is-scrolled="allTables.length > 20"
                    :virtual-scroller-options="{ itemSize: 38 }" />
                <InputSelect v-model="selectedMarketingId" label="Marketing" id="filter-marketing"
                    :options="allMarketings" placeholder="Pilih marketing" optionLabel="name" optionValue="id"
                    :virtual-scroller-options="{ itemSize: 38 }" :is-scrolled="allMarketings.length > 10" />
                <InputSelect v-model="selectedPaymentMethodId" label="Metode Pembayaran" id="filter-payment-method"
                    :options="allPaymentMethods" placeholder="Pilih metode pembayaran" optionLabel="name"
                    optionValue="id" />
                <InputSelect v-model="selectedCashRegisterId" label="Cash Register" id="filter-cash-register"
                    :options="optionCashRegister" placeholder="Pilih cash register" optionLabel="name"
                    optionValue="id" />
                <InputSelect v-model="selectedGlobalDiscountId" label="Global Discount" id="filter-global-discount"
                    :options="allGlobalDiscounts" placeholder="Pilih global discount" optionLabel="name"
                    optionValue="id" />
                <InputSelect v-model="selectedStatus" label="Status" id="filter-status" :options="allStatuses"
                    placeholder="Pilih status" optionLabel="name" optionValue="id" />
            </div>
            <div class="modal-footer p-5">
                <div class="flex justify-center">
                    <SubmitButton id="reset" button_name="Reset"
                        button_class="mx-1 text-red-600 border-red-600 hover:text-white hover:bg-red-600"
                        @click="resetFilter" />
                    <SubmitButton id="close" button_name="Close"
                        button_class="mx-1 text-red-600 border-red-600 hover:text-white hover:bg-red-600"
                        @click="closeModal" />
                    <SubmitButton id="submit" button_name="Filter"
                        button_class="mx-1 bg-color-1 hover:bg-color-2 text-color-4" @click="submitFilter" />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import SubmitButton from '@/components/form/SubmitButton.vue';
    import { mapGetters } from 'vuex';
    import InputSelect from '@/components/form/InputSelect.vue';
    import { DatePicker } from 'primevue';
    import { formatTime } from '@/helpers/formatTime';

    export default {
        name: "ModalFilterTable",
        props: {
            filter: {
                type: Object,
                default: null,
            }
        },
        components: {
            SubmitButton, InputSelect, DatePicker
        },
        computed: {
            ...mapGetters('marketings', ['allMarketings']),
            ...mapGetters('tables', ['allTables']),
            ...mapGetters('cash_registers', ['allCashRegisters']),
            ...mapGetters('payment_methods', ['allPaymentMethods']),
            ...mapGetters('global_discounts', ['allGlobalDiscounts']),
            optionCashRegister() {
                return this.allCashRegisters.map((item) => {
                    return {
                        name: `${formatTime(item.time_start)} - ${formatTime(item.time_end)}`,
                        id: item.id
                    }
                })
            }
        },
        async created() {
            try {
                // Fetch required data in parallel
                await Promise.all([
                    this.$store.dispatch("tables/fetchTables", { limit: 1000 }),
                    this.$store.dispatch("payment_methods/fetchPaymentMethods", { limit: 1000 }),
                    this.$store.dispatch("marketings/fetchMarketings", { limit: 1000 }),
                    this.$store.dispatch("cash_registers/fetchCashRegisters", { limit: 1000 }),
                    this.$store.dispatch("global_discounts/fetchGlobalDiscounts", { limit: 1000 }),
                ]);
                this.isLoading = false;
            } catch (error) {
                console.log(error);
                this.errorMessage =
                    error.message ||
                    "Terjadi kesalahan saat memuat data. Silakan coba lagi.";
                this.showErrorDialog = true;
                this.isLoading = false;
            }
        },
        data() {
            return {
                showModal: true,
                selectedType: '',
                rangeDate: null,
                allTypes: [
                    { id: 'dine_in', name: 'Dine In' },
                    { id: 'take_away', name: 'Take Away' },
                    { id: 'staff', name: 'Staff' },
                ],
                selectedStatus: '',
                allStatuses: [
                    { id: 'paid', name: 'Paid' },
                    { id: 'pending', name: 'Pending' },
                    { id: 'canceled', name: 'Canceled' },
                ],
                filterCapacity: '',
                selectedTableId: '',
                selectedMarketingId: '',
                selectedPaymentMethodId: '',
                selectedCashRegisterId: '',
                selectedGlobalDiscountId: '',
            }
        },
        methods: {
            formatTime,
            closeModal() {
                this.showModal = false;
                setTimeout(() => {
                    this.$emit('closeModal');
                }, 200);
            },
            submitFilter() {
                this.$emit('submitFilter', {
                    rangeDate: this.rangeDate,
                    type: this.selectedType,
                    status: this.selectedStatus,
                    table_id: this.selectedTableId,
                    marketing_id: this.selectedMarketingId,
                    payment_method_id: this.selectedPaymentMethodId,
                    cash_register_id: this.selectedCashRegisterId,
                    global_discount_id: this.selectedGlobalDiscountId,
                });
                this.closeModal();
            },
            resetFilter() {
                this.selectedType = '';
                this.rangeDate = null;
                this.selectedStatus = '';
                this.filterCapacity = '';
                this.selectedTableId = '';
                this.selectedMarketingId = '';
                this.selectedPaymentMethodId = '';
                this.selectedCashRegisterId = '';
                this.selectedGlobalDiscountId = '';
            }
        }
    }
</script>